import { Flex, FormControl, Textarea } from '@chakra-ui/react';

const ReferenceRatingComment = ({
  comment,
  value,
  setFieldValue,
}: ReferenceRatingCommentProps): JSX.Element => {
  return (
    <Flex mb={4} width="100%">
      <FormControl id={comment} mb={2} width="100%">
        <Textarea
          value={value}
          onChange={(e) => setFieldValue(comment, e.currentTarget.value)}
          border="1px solid #999999"
          bg="#FAF8EC"
          placeholder="Add comment"
          _placeholder={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '19.2px',
            letterSpacing: '2%',
            color: '#808080',
          }}
        />
      </FormControl>
    </Flex>
  );
};

export default ReferenceRatingComment;
